export default {
  // 搜索相關
  searchPlaceholder: "搜索地址/哈希/調證用戶ID",
  dataDetails: "數據詳情",

  // 頁面標題
  transactionDetails: "交易詳情",

  // 按鈕
  joinCanvas: "加入畫布",
  browserView: "瀏覽器查看",

  // 交易信息
  transactionHash: "交易哈希值",
  blockTime: "出塊時間",
  inputAmount: "輸入數量",
  outputAmount: "輸出數量",
  transactionFee: "交易手續費",

  // 消息提示
  copySuccess: "複製成功",
  addressNotFound: "沒有查出該地址",
};
